module.exports = __webpack_public_path__ + "static/img/HOME PAGE_desktop_regular lcon2.2659fe0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/user/HOME PAGE_desktop_regular lcon2.png
// module id = BONB
// module chunks = 0